export const KlaviyoFeatureObj = [
  {
    title: "Keep your subscribers in a single place",
    desc: "Add new subscribers created in CausalFunnel to your Klaviyo account",
  },
  {
    title: "Pre-chat survey",
    desc: "Collect new subscribers when they want to start chatting with you",
  },
  {
    title: "Chatbots",
    desc: "Use lead generation bots to automatically sync new subscribers",
  },
  {
    title: "Manual settings",
    desc: "Change subscribers status manually during a conversation, sync automatically",
  },
];

export const KlayiyoInstallGuide = [
  { id: 1, content: "Log in to your Klaviyo account" },
  { id: 2, content: "Go to the 'Account' option of your profile" },
  { id: 3, content: "Select 'Settings' and then 'API Keys'" },
  { id: 4, content: "Press 'Create Private API Key'" },
  { id: 5, content: "Name your Private API Key" },
  {
    id: 6,
    content:
      "Now you need to select Access Level. For CausalFunnel integration to work properly, select ‘Full Access’ to List, Profiles and Subscriptions Scopes",
  },
  { id: 7, content: "Press ‘Create’" },
  {
    id: 8,
    content:
      "Now copy your Private Key and paste it when creating a new connection like in the picture below.",
  },
];
